module.exports = __webpack_public_path__ + "static/media/mw13.599becc3.webp";